<template>
    <div>
        <v-header title="职业轨迹"></v-header>
        <div class="conH"></div>
        <el-row>
            <el-col :span="10" class="col">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="titleFont">职业变更轨迹</span>
                    </div>
                    <div class="main">
                        <ul>
                            <li v-for="(item,index) in res.postHistorys" :key="item.key" v-if="index=== 0">
                                <span class="checked-statu">{{item.rankStartDate}}</span><img src="@/assets/trajectory/trajectory@2x.png" style="width:20px;padding-top: 15px" alt="">
                                <span class="checked-status">{{item.rankName}}</span>
                            </li>
                            <li v-for="(item,index) in res.postHistorys" :key="item.key" v-if="index!== 0">
                                <hr>
                                <span>{{item.rankStartDate}}</span><img src="@/assets/trajectory/default_icon_Career_trajectory@2x.png" alt="">
                                <span>{{item.rankName}}</span>
                            </li>
                        </ul>
                    </div>
                </el-card>
            </el-col>
             <el-col :span="10" class="col">
                <el-card class="box-card">
                    <div slot="header" class="clearfix-right">
                        <span>团队变更轨迹</span>
                    </div>
                   <div class="main">
                    <ul>
                        <li v-for="(item,index) in res.teamHistorys" :key="item.key" v-if="index===0">
                            <span class="checked-statu-right">{{item.teamStartDate}}</span><img src="@/assets/trajectory/now_team_icon_Careertrajectory@2x.png" style="width:20px;padding-top: 15px;" alt="">
                            <span class="checked-status-right">{{item.teamName}}</span>
                        </li>
                        <li v-for="(item,index) in res.teamHistorys" :key="item.key" v-if="index!== 0">
                            <hr>
                            <span>{{item.teamStartDate}}</span><img src="@/assets/trajectory/default_icon_Career_trajectory@2x.png" alt="">
                            <span>{{item.teamName}}</span>
                        </li>
                    </ul>
                </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import api from '@/modules/api'
import url from '@/modules/url'
import vHeader from '@/layout/Header1.vue'
export default {
    components: {vHeader},
  data () {
    return {
      active: 2,
      res: ''
    }
  },
  methods: {
    demo () {
      let option = {

      }
      let that = this
      api.post(url.trajectory, option, function (res) {
        that.res = res.data
      })
    }
  },
  created () {

  },
  mounted () {
    this.demo()
  }
}
</script>

<style scoped>
.main {
    text-align: center;
    overflow-y: scroll;
    height: 66vh;
}

.main hr {
    width: 1px;
    height: 15vh;
    background-color: #ccc;
    margin: -23.2vh 0 -3vh 48.9%;
}

.main ul {
    font-size: 30px;
    list-style: none;
    padding-left: 20px;
}

.main ul li:last-child {
    color: #111111;
    margin-top: 100px;
    text-align: center;
}

.main ul li {
    margin: 0 5vh 17vh 0;
}

.main ul li span {
    display: inline-block;
    width: 44%;
    font-size: 15px;
}

.main ul li img {
    margin: 0 3px;
    width: 15px;
}

.checked-statu {
    color: #3D62AD;
    display: inline-block;
    width: 100px;
    height: 56px;
}

.checked-status {
    display: inline-block;
    width: 20px;
    height: 25px;
    padding-top: 5px;
    color: #fff;
    /* background: url('../../assets/trajectory/zhijibg.png') center left no-repeat; 
    background-size: 100% 100%;*/
    background: #3D62AD;
    white-space: nowrap;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    position:relative;
    border-radius: 3px;
}
.checked-status:before{
    content: " ";
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 8px;
    left: -12px;
    border-right-color: #3D62AD;
    border-width: 6px;
}
.checked-statu-right {
    color: #3DAD9F;
    display: inline-block;
    width: 100px;
    height: 56px;
}

.checked-status-right {
    display: inline-block;
    width: 20px;
    height: 25px;
    padding-top: 5px;
    color: #fff;
    /*  url('../../assets/trajectory/Roundedrectangle_icon_Careertrajectory@2x.png') center left no-repeat; 
    background-size: 100% 100%;*/
    background:#3DAD9F;
    white-space: nowrap;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    position: relative;
    border-radius: 3px;
}
.checked-status-right:before{
    content: " ";
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 8px;
    left: -12px;
    border-right-color: #3DAD9F;
    border-width: 6px;
}
.box-card{
    width: 100%;
    margin-top: 5vh;
}
.col{
    width: 45%;
    margin-left: 4vh;
}
.clearfix{
    color: #3D62AD;
    font-weight:bold;
    text-align: center;
}
.clearfix-right{
    color: #3DAD9F;
    font-weight:bold;
    text-align: center;
}
.main::-webkit-scrollbar {
  width: 4px;
  background-color: #ffffff;
}
.main::-webkit-scrollbar-thumb  {
    background: #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/trajectory.vue